import React, { createContext, useContext, useEffect, useState } from 'react';
import { firestore } from '../Firebase';

const TitleContext = createContext();

export function TitleProvider({ children }) {
  const [pageTitle, setPageTitle] = useState(
    process.env.REACT_APP_WEBSITE_NAME || 'showlive.co'
  );

  useEffect(() => {
    // Listen for changes in the customization document
    const unsubscribe = firestore
      .collection('settings')
      .doc('customization')
      .onSnapshot((doc) => {
        if (doc.exists && doc.data().pageTitle) {
          setPageTitle(doc.data().pageTitle);
          document.title = doc.data().pageTitle;
        }
      });

    return () => unsubscribe(); // Cleanup subscription
  }, []);

  return (
    <TitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </TitleContext.Provider>
  );
}

export function useTitle() {
  return useContext(TitleContext);
}
